import { FlowchartStep } from './../../../shared/models/flowchart-step.model';
import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
	selector: 'flowchart-step',
	templateUrl: './flowchart-step.component.html',
	providers: [],
	styleUrls: ['./flowchart-step.component.scss']
})

export class FlowchartStepComponent implements OnInit {
	@HostBinding('class.move-cursor') get noDisableDrag() {
		return !this.disableDrag;
	}

	@Input() step: FlowchartStep;
	@Input() selected = false;
	@Input() statsMode = false;
	@Input() disableDrag: boolean;

	constructor(
	) { }

	ngOnInit() {

	}
}
